import axios from 'axios'

export default {
    getProductPricingList({commit}, params){
        return axios.post('/api/background/product/manage/list', params)
    },
    addProductPricing({commit}, params){
        return axios.post('/api/background/product/manage/add', params)
    },
    modifyProductPricing({commit}, params){
        return axios.post('/api/background/product/manage/modify', params)
    },
    deleteProductPricing({commit}, params){
        return axios.post('/api/background/product/manage/delete', params)
    },
    getMessagePricingList({commit}, params){
        return axios.post('/api/background/product/sms/list', params)
    },
    addMessagePricing({commit}, params){
        return axios.post('/api/background/product/sms/add', params)
    },
    modifyMessagePricing({commit}, params){
        return axios.post('/api/background/product/sms/modify', params)
    },
    deleteMessagePricing({commit}, params){
        return axios.post('/api/background/product/sms/delete', params)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/product.js